




import Vue from 'vue';
import GuideModule from '@/components/guide.vue';
import { analytics } from '../../common/analytics';
import { pageCids, metricPoints } from '@/common/statistics';
import { monitor } from '@/common/monitor';

// 此页面为提单页单独的极速支付介绍页面，共用极速支付未开通模块
export default Vue.extend({
  components: {
    GuideModule,
  },
  created() {
    analytics.pv(pageCids.guidePage);
  },
  mounted() {
    monitor.reportMetric(metricPoints.guidePage);
    monitor.reportTTI();
  },
});
